import type { MCartLimit } from "@/Models/MCartLimit/MCartLimit";
import React, { useState, useCallback } from "react";

export const useCartLimit = () => {
  const [cartLimitItem, setCartLimitItem] = useState<MCartLimit | null>(null);

  // Guardar un nuevo artículo (borra el anterior)
  const saveCartLimit = useCallback((item: MCartLimit) => {
    setCartLimitItem(item);
  }, []);

  // Borrar el artículo actual
  const clearCartLimit = useCallback(() => {
    setCartLimitItem(null);
  }, []);

  // Consultar el artículo actual
  const getCartLimit = useCallback((): MCartLimit | null => {
    return cartLimitItem;
  }, [cartLimitItem]);

  return {
    cartLimitItem,
    saveCartLimit,
    clearCartLimit,
    getCartLimit,
  };
};
